module.exports = __webpack_public_path__ + "assets/img/stumped.png?45ee6f99a36e75dcead509b0a5ed39bf";